import React, { useState, useEffect } from 'react'
import {
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Typography,
  Button,
  Avatar
} from '@material-ui/core'
import { Link, NavLink } from 'react-router-dom'
import MenuIcon from '@material-ui/icons/Menu'
import { LineStyle, PowerSettingsNewOutlined } from '@material-ui/icons'

import { useContext } from 'react'
import { AuthContext } from '../../context/authContext/AuthContext'

const DrawerComponent = () => {
  const [openDrawer, setOpenDrawer] = useState(false)
  const { user } = useContext(AuthContext)
  console.log(user)
  const logoutFc = () => {
    localStorage.clear()
    window.location.reload()
  }

  useEffect(() => {}, [])

  return (
    <>
      <Drawer open={openDrawer} onClose={() => setOpenDrawer(false)}>
        {user && user.result.isAdmin === true ? (
          <List>
            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <NavLink
                  to={`${process.env.PUBLIC_URL}/dashboard`}
                  activeClassName='active'
                >
                  <LineStyle className='sidebarIcon' />
                  Manage Affiliates
                </NavLink>
              </ListItemText>
            </ListItem>
            <Divider />
            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <NavLink
                  to={`${process.env.PUBLIC_URL}/upload-data`}
                  activeClassName='active'
                >
                  Upload Data
                </NavLink>
              </ListItemText>
            </ListItem>
            <Divider />
            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <NavLink
                  to={`${process.env.PUBLIC_URL}/marketing-resources`}
                  activeClassName='active'
                >
                  Marketing Resources
                </NavLink>
              </ListItemText>
            </ListItem>
            <Divider />
            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                {user ? (
                  <div className='profile' style={{ display: 'flex' }}>
                    <Typography className='userName' variant='h6'>
                      {user.result.FirstName} {user.result.LastName}
                    </Typography>
                  </div>
                ) : (
                  ''
                )}
              </ListItemText>
            </ListItem>
            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                {user ? (
                  <div className='profile'>
                    <Button
                      variant='contained'
                      className='logout'
                      color='secondary'
                      onClick={logoutFc}
                      style={{ color: 'white' }}
                    >
                      <PowerSettingsNewOutlined className='sidebarIcon' />
                      Logout
                    </Button>
                  </div>
                ) : (
                  ''
                )}
              </ListItemText>
            </ListItem>
          </List>
        ) : (
          <List>
            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                <NavLink
                  to={`${process.env.PUBLIC_URL}/user`}
                  activeClassName='active'
                >
                  <LineStyle className='sidebarIcon' />
                  Home
                </NavLink>
              </ListItemText>
            </ListItem>
            <Divider />
            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                {user ? (
                  <div className='profile' style={{ display: 'flex' }}>
                    <Typography className='userName' variant='h6'>
                      {user.result.FirstName} {user.result.LastName}
                    </Typography>
                  </div>
                ) : (
                  ''
                )}
              </ListItemText>
            </ListItem>
            <Divider />
            <ListItem onClick={() => setOpenDrawer(false)}>
              <ListItemText>
                {user ? (
                  <div className='profile'>
                    <Button
                      variant='contained'
                      className='logout'
                      color='secondary'
                      onClick={logoutFc}
                      style={{ color: 'white' }}
                    >
                      <PowerSettingsNewOutlined className='sidebarIcon' />
                      Logout
                    </Button>
                  </div>
                ) : (
                  ''
                )}
              </ListItemText>
            </ListItem>
          </List>
        )}
      </Drawer>
      <IconButton
        onClick={() => setOpenDrawer(!openDrawer)}
        className='menuIcon'
      >
        <MenuIcon style={{ fontSize: '3rem' }} />
      </IconButton>
    </>
  )
}
export default DrawerComponent
